import { Flex, message, Modal, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { CustomButton } from '@/components/ui';
import './index.scss';
import { updateBooking } from '@/api/booking';
import queryClient from '@/client/queryClient';
import { BookingStatusEnum } from '@/types';
import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { notifyActionError } from '@/helpers/subscriptionError';
export const CompleteBooking = (props: any) => {
  const dispatch = useDispatch();

  const mutateSession = useMutation({
    mutationKey: ['update-session'],
    mutationFn: async () => {
      await Promise.all([
        updateBooking(props.bookingId, {
          status: BookingStatusEnum.FINISHED,
        }),
      ]);
    },
    onSuccess: () => {
      message.success('Booking completed successfully!');
      props.onCancel();
      queryClient.invalidateQueries({
        queryKey: ['bookings'],
      });
      // TCX-790: refresh the scoped booking DETAIL (['booking', userId, id]).
      queryClient.invalidateQueries({
        queryKey: ['booking'],
      });
      queryClient.invalidateQueries({
        queryKey: ['notifications'],
      });
      // `MyBookings` auto-opens the franchisor review modal based on `latest-session`.
      // Ensure it refetches immediately after marking the booking as finished.
      queryClient.invalidateQueries({
        queryKey: ['latest-session'],
      });
      queryClient.invalidateQueries({
        queryKey: ['consultant-feedback-request'],
      });
    },
    onError: (error) => {
      // TCX-900: distinguishes a retryable Stripe outage from a rejection.
      notifyActionError(
        error,
        'Failed to complete the booking or confirm the meeting.',
      );
    },
  });

  const onComplete = () => {
    mutateSession.mutate();
  };

  return (
    <Modal
      closeIcon={<CloseOutlined />}
      open={props.open}
      onCancel={props.onCancel}
      width={460}
      centered
      footer={null}
      className={'complete-booking-modal'}
      styles={{
        mask: {
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
      }}
      {...props}
    >
      <Flex vertical className={'header'} align={'center'} gap={16}>
        <Typography.Text className={'title'}>
          Are you sure this call was completed?
        </Typography.Text>

        <Typography.Text className={'description'}>
          Clicking complete will charge the franchisor
        </Typography.Text>
      </Flex>

      <Flex vertical gap={12}>
        <CustomButton
          onClick={onComplete}
          type={'primary'}
          text={mutateSession.isPending ? 'COMPLETING...' : 'MARK COMPLETE'}
          disabled={mutateSession.isPending}
        />

        <CustomButton
          type={'default'}
          onClick={props.onCancel}
          text={'GO BACK'}
          disabled={mutateSession.isPending}
        />
      </Flex>
    </Modal>
  );
};
